<script setup lang="ts">
import { Link, usePage } from '@inertiajs/vue3';
import { computed } from 'vue';
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';
import { useTranslations } from '@/composables/useTranslations';
import { about, privacy, terms } from '@/routes';

const page = usePage();
const { t } = useTranslations();

const appName = computed(() => page.props.name);
const currentYear = new Date().getFullYear();
</script>

<template>
    <footer
        class="mt-auto border-t border-sidebar-border/80 bg-muted/25 dark:bg-muted/15"
        role="contentinfo"
    >
        <div
            class="mx-auto flex max-w-7xl flex-col gap-4 px-3 py-5 sm:px-4 sm:py-6 md:flex-row md:items-center md:justify-between md:gap-6"
        >
            <div
                class="flex flex-col items-center gap-3 text-center md:items-start md:text-left"
            >
                <p class="text-xs text-pretty text-muted-foreground md:text-sm">
                    &copy;
                    {{ currentYear }}
                    {{ appName }}.
                    {{ t('tools.footer.rights', 'All rights reserved.') }}
                </p>
                <nav
                    aria-label="Legal and policies"
                    class="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 md:justify-start"
                >
                    <Link
                        :href="about.url()"
                        prefetch
                        class="text-xs text-muted-foreground underline-offset-4 transition-colors hover:text-foreground hover:underline sm:text-sm"
                    >
                        {{ t('tools.footer.about', 'About') }}
                    </Link>
                    <Link
                        :href="privacy.url()"
                        prefetch
                        class="text-xs text-muted-foreground underline-offset-4 transition-colors hover:text-foreground hover:underline sm:text-sm"
                    >
                        {{ t('tools.footer.privacy', 'Privacy policy') }}
                    </Link>
                    <Link
                        :href="terms.url()"
                        prefetch
                        class="text-xs text-muted-foreground underline-offset-4 transition-colors hover:text-foreground hover:underline sm:text-sm"
                    >
                        {{ t('tools.footer.terms', 'Terms of service') }}
                    </Link>
                </nav>
            </div>
            <div
                class="flex w-full flex-wrap items-center justify-center md:w-auto md:justify-end"
            >
                <LanguageSwitcher />
            </div>
        </div>
    </footer>
</template>
